import { blinkConstants } from '@thoughtspot/blink-constants';
export function normalizeHex(color) {
    if (!color)
        return '';
    const upper = color.toUpperCase();
    if (upper.startsWith('#') && upper.length === 9) {
        return upper.substring(0, 7);
    }
    return upper;
}
const NORM_DARK = normalizeHex(blinkConstants.themeColor.DARK);
const NORM_TWO_TONE = normalizeHex(blinkConstants.themeColor.TWO_TONE);
export function resolveThemeMode(appPanelColor, radiantEnabled) {
    if (!appPanelColor) {
        return radiantEnabled
            ? { radiant: true, mode: 'light' }
            : {
                radiant: false,
                legacyType: 'dark',
                color: blinkConstants.themeColor.DARK,
            };
    }
    const color = appPanelColor;
    if (color === blinkConstants.themeColor.RADIANT_LIGHT) {
        return radiantEnabled
            ? { radiant: true, mode: 'light' }
            : {
                radiant: false,
                legacyType: 'two-tone',
                color: blinkConstants.themeColor.TWO_TONE,
            };
    }
    if (color === blinkConstants.themeColor.RADIANT_DARK) {
        return radiantEnabled
            ? { radiant: true, mode: 'dark' }
            : {
                radiant: false,
                legacyType: 'dark',
                color: blinkConstants.themeColor.DARK,
            };
    }
    if (color === blinkConstants.themeColor.CUSTOM) {
        return radiantEnabled
            ? { radiant: true, mode: 'brand', sourceHex: color }
            : { radiant: false, legacyType: 'custom', color };
    }
    const norm = normalizeHex(color);
    if (norm === NORM_TWO_TONE) {
        return radiantEnabled
            ? { radiant: true, mode: 'light' }
            : { radiant: false, legacyType: 'two-tone', color };
    }
    if (norm === NORM_DARK) {
        return radiantEnabled
            ? { radiant: true, mode: 'dark' }
            : { radiant: false, legacyType: 'dark', color };
    }
    return radiantEnabled
        ? { radiant: true, mode: 'brand', sourceHex: color }
        : { radiant: false, legacyType: 'custom', color };
}
export function resolveApplyAsTopNavColor(appPanelColor, persisted) {
    if (typeof persisted === 'boolean') {
        return persisted;
    }
    const resolved = resolveThemeMode(appPanelColor, true);
    return resolved.radiant && resolved.mode === 'brand';
}
//# sourceMappingURL=resolve-theme-mode.js.map